<template>
      <div class="userCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'user', params: {} }">
          User
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'userCreate', params: {} }">
            Create User
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create User</v-card-title>
          <v-card-text>
            <user-form></user-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import UserForm from './UserForm.vue';

    export default {
      name: 'user',
      components: {
        UserForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    